import { KeyValue } from '../..'

export interface CinemaFeaturesApiModel {
    name: string
    CinemaFeaturesElement: {
        subheading: string
        introText: string
        cinemas: { nodeId: number; name: string; url: string }[]
        selectedAttributes: { attributePicker: { options: string[] } }
    }
}

export interface CinemaFeature {
    name: string
    subheading: string
    introText: string
    attributes: KeyValue[]
    cinemas: string[]
}

export const mapCinemaFeatures = (data: CinemaFeaturesApiModel[], attributesData: KeyValue[]): CinemaFeature[] => {
    const result = data.map<CinemaFeature>(e => {
        const attributes = e.CinemaFeaturesElement?.selectedAttributes?.attributePicker?.options.map(a => ({
            key: a,
            value: a,
        }))

        if (attributesData) {
            for (let attr of attributes) {
                const attrKeyVal = attributesData.find(a => a.key == attr.key)
                if (attrKeyVal) attr.value = attrKeyVal.value
            }
        }

        return {
            name: e.name,
            subheading: e.CinemaFeaturesElement?.subheading,
            introText: e.CinemaFeaturesElement?.introText,
            attributes: attributes,
            cinemas: e?.CinemaFeaturesElement.cinemas.map(e => e.name),
        }
    })

    return result
}
